/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerConfigPlayslipsCopy
 */
export interface CustomerConfigPlayslipsCopy {
    /**
     * 
     * @type {string}
     * @memberof CustomerConfigPlayslipsCopy
     */
    qrCodeScreen?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerConfigPlayslipsCopy
     */
    homeScreenNewOrder?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerConfigPlayslipsCopy
     */
    homeScreenNoSavedOrders?: string;
}

/**
 * Check if a given object implements the CustomerConfigPlayslipsCopy interface.
 */
export function instanceOfCustomerConfigPlayslipsCopy(value: object): value is CustomerConfigPlayslipsCopy {
    return true;
}

export function CustomerConfigPlayslipsCopyFromJSON(json: any): CustomerConfigPlayslipsCopy {
    return CustomerConfigPlayslipsCopyFromJSONTyped(json, false);
}

export function CustomerConfigPlayslipsCopyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerConfigPlayslipsCopy {
    if (json == null) {
        return json;
    }
    return {
        
        'qrCodeScreen': json['qrCodeScreen'] == null ? undefined : json['qrCodeScreen'],
        'homeScreenNewOrder': json['homeScreenNewOrder'] == null ? undefined : json['homeScreenNewOrder'],
        'homeScreenNoSavedOrders': json['homeScreenNoSavedOrders'] == null ? undefined : json['homeScreenNoSavedOrders'],
    };
}

export function CustomerConfigPlayslipsCopyToJSON(value?: CustomerConfigPlayslipsCopy | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'qrCodeScreen': value['qrCodeScreen'],
        'homeScreenNewOrder': value['homeScreenNewOrder'],
        'homeScreenNoSavedOrders': value['homeScreenNoSavedOrders'],
    };
}

